import initialState from "App/redux/initialState";
import * as actions from "./actions";

export const users = (state = initialState.users, action) => {
  switch (action.type) {
    case actions.USERS_GET:
      return {
        ...state,
        loading: true,
      };
    case actions.USERS_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        loadedOn: Date.now(),
        results: action.payload,
      };
    case actions.USERS_GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        loadedOn: null,
        results: [],
      };
    default:
      return state;
  }
};
